/**
 * Récidive de lavage impossible (CQ-01, les-eugene-docs regle-gestion-controle-qualite-v2 §A).
 *
 * Tout est calculé côté API et figé sur l'anomalie LAVAGE_IMPOSSIBLE : `recidive` (bool) et
 * `details.precedente = {id, date: "YYYY-MM-DD HH:mm", raisons: string[]} | null`.
 * Ici : uniquement de la présentation (libellés, filtre) — aucune règle métier, jamais de recalcul.
 * Fonctions pures (testées en vitest, environnement node : pas de moment, pas de MUI).
 */

/** "2026-09-04 09:00" → "04/09/2026 09h00" (format API `Y-m-d H:i`, sans fuseau). */
export function formatDatePrecedente(date) {
    if (!date || typeof date !== 'string') return null;
    const m = date.match(/^(\d{4})-(\d{2})-(\d{2})(?: (\d{2}):(\d{2}))?/);
    if (!m) return date;
    const [, y, mo, d, h, mi] = m;
    return h ? `${d}/${mo}/${y} ${h}h${mi}` : `${d}/${mo}/${y}`;
}

export function isRecidive(anomalie) {
    return anomalie?.recidive === true;
}

/**
 * Texte du passage précédent, pour le tooltip de la worklist et le bloc du tiroir.
 * Retourne null si l'anomalie n'est pas une récidive.
 * Ex. : "Passage précédent déjà impossible le 04/09/2026 09h00 — Accès bloqué"
 */
export function describePrecedente(anomalie) {
    if (!isRecidive(anomalie)) return null;
    const p = anomalie.details?.precedente;
    if (!p) return 'Passage précédent déjà impossible';
    const quand = formatDatePrecedente(p.date);
    const raisons = (p.raisons ?? []).filter(Boolean);
    return 'Passage précédent déjà impossible'
        + (quand ? ` le ${quand}` : '')
        + (raisons.length ? ` — ${raisons.join(', ')}` : ' — sans raison renseignée');
}

/** Filtre « récidives seules » de la worklist. */
export function filterRecidives(anomalies, recidivesSeules) {
    const list = anomalies ?? [];
    return recidivesSeules ? list.filter(isRecidive) : list;
}

export function countRecidives(anomalies) {
    return (anomalies ?? []).filter(isRecidive).length;
}
